import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';
import { mediaQuery } from '../../../styles/helpers';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    button: {
      margin: 'auto',
      gridColumn: '1 / -1',
      backgroundColor: 'var(--x-bg-8)',
      marginTop: 8,
      paddingInline: 42,

      [mediaQuery(breakpoints.mobile)]: {
        width: '100%',
        paddingInline: 'initial',
      },
    },
  }),
  { name: 'LoadMore' },
);

export default useStyles;
